<page-heading [title]="'shared.settingsWebhook.pageTitle' | translate"
  [description]="'shared.settingsWebhook.pageDescription' | translate" />

<div class="row">
  <div class="col-12">
    <div class="card">
      <div class="card-body">
        <div class="row">
          <div class="col-xs-12 col-md-9 input-trend-search">
            <input type="search" #searchBox class="form-control" [placeholder]="'shared.settingsWebhook.searchPlaceholder' | translate"
              (keyup)="search(searchBox.value)" />
            <span class="mdi mdi-magnify search-icon ml-2"></span>
          </div>

          <div class="col-xs-12 col-md-3  btn-group trend-button">
            <button class="btn btn-info fw-bold" (click)="edit()">{{ 'shared.settingsWebhook.add' | translate }}</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="card">
  @if (loadingContent) {
  <content-loading-list></content-loading-list>
  }

  @if (!loadingContent && (settingsWebhook.items?.length == 0 || (filteredItems?.length == 0 &&
  settingsWebhook.items?.length > 0))) {
  <empty-records-legacy-component
    [message]="settingsWebhook.items?.length == 0 ? ('shared.settingsWebhook.emptyNoRecords' | translate) : ('shared.settingsWebhook.emptyNoResults' | translate)"
    [subMessage]="settingsWebhook.items?.length == 0 ? ('shared.settingsWebhook.emptySubMessage' | translate) : ('shared.settingsWebhook.emptySubMessage' | translate)"
    [buttonClass]="'btn btn-info fw-bold'" (emitEvent)="edit()">
  </empty-records-legacy-component>
  }

  @if (!loadingContent && filteredItems?.length > 0) {
  <div class="card-body table-responsive">
    <table class="table table-hover table-centered mb-0">
      <thead>
        <tr>
          <th class="text-primary-emphasis">{{ 'shared.settingsWebhook.columnNameUrl' | translate }}</th>
          <th class="text-primary-emphasis">{{ 'shared.settingsWebhook.columnStatus' | translate }}</th>
          <th class="text-primary-emphasis">{{ 'shared.settingsWebhook.columnEvents' | translate }}</th>
          <th><span class="sr-only"></span></th>
        </tr>
      </thead>
      <tbody>
        @for (item of filteredItems; track $index) {
        <tr>
          <td>
            <strong>{{item.name}}</strong><br />
            {{item.url}}
          </td>
          <td>
            @if (item.actived) {
            <span class="badge font-14 bg-success text-capitalize ">{{ 'shared.settingsWebhook.statusActive' | translate }}</span>
            }
            @if (!item.actived) {
            <span class="badge font-14 text-bg-secondary text-capitalize">{{ 'shared.settingsWebhook.statusInactive' | translate }}</span>
            }
          </td>
          <td>
            @for (event of item.events; track $index) {
            @if (event === 'ATTENDANCE_CREATE') {
            <span class="badge font-14 bg-primary mr-2">{{ 'shared.settingsWebhook.eventAttendanceCreate' | translate }}</span>
            }
            @if (event === 'ATTENDANCE_CLOSE') {
            <span class="badge font-14 bg-primary mr-2">{{ 'shared.settingsWebhook.eventAttendanceClose' | translate }}</span>
            }
            @if (event === 'ATTENDANCE_NEW_MESSAGE') {
            <span class="badge font-14 bg-primary mr-2">{{ 'shared.settingsWebhook.eventNewMessage' | translate }}</span>
            }
            @if (event === 'ATTENDANCE_REFERRAL_CREATE') {
            <span class="badge font-14 bg-primary mr-2">{{ 'shared.settingsWebhook.eventReferralCreate' | translate }}</span>
            }
            @if (event === 'ATTENDANCE_TRANSFER') {
            <span class="badge font-14 bg-primary mr-2">{{ 'shared.settingsWebhook.eventTransfer' | translate }}</span>
            }
            }
          </td>
          <td>
            <div class="d-flex justify-content-end">
              <button type="button" class="btn btn-dropdown-list" [matMenuTriggerFor]="menu">
                <i class="mdi mdi-dots-vertical text-primary-emphasis"></i>
              </button>

              <mat-menu #menu="matMenu">
                <button mat-menu-item tabindex="0" (click)="edit(item)">{{ 'shared.settingsWebhook.edit' | translate }}</button>
                <button mat-menu-item tabindex="0" (click)="delete(item)">{{ 'shared.settingsWebhook.delete' | translate }}</button>
              </mat-menu>
            </div>
          </td>
        </tr>
        }
      </tbody>
    </table>
  </div>
  }

</div>